import { CLIENT_TYPES } from '../constants/client.constants';

export function getInitialCreateClientDialogState(emptyClient) {
  return {
    model: {
      ...emptyClient,
      tipoCliente: emptyClient?.tipoCliente || CLIENT_TYPES.CEDENTE,
      contattiPersonali: { ...(emptyClient?.contattiPersonali || { email: '', phone: '' }) },
      contattiAziendali: { ...(emptyClient?.contattiAziendali || { email: '', phone: '' }) },
      documenti: [...(emptyClient?.documenti || [])],
    },
    referredByType: 'staff',
    customReferral: '',
  };
}

export function validateCreateClientModel(model) {
  if (
    !model.name ||
    !model.company ||
    !model.businessName ||
    !model.vatNumber ||
    !model.codiceFiscale ||
    !model.tipoCliente
  ) {
    return 'Compila tutti i campi obbligatori';
  }

  return null;
}
